module.exports = __webpack_public_path__ + "img/AbdulkhaliqYa3qubi-SquareArtwork (29).d5c67471.jpg";